"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("./Modal"));
var _PostMessage = require("../api/PostMessage");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class OkModal extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "closeModal", () => {
      const {
        closeModalCallback,
        display,
        header,
        fullWidth
      } = this.props;
      this.setState({
        display: false
      });
      closeModalCallback();
      _PostMessage.PostMessage.postMessageCoreEvent('ok-modal-close', {
        display,
        header,
        fullWidth
      });
    });
    this.state = {
      display: props.display
    };
  }
  componentDidUpdate(prevProps) {
    const {
      display
    } = this.props;
    if (typeof prevProps.display !== 'undefined' && prevProps.display !== display) {
      this.setState({
        display
      });
    }
  }
  render() {
    const {
      header,
      message,
      portalContainer,
      fullWidth
    } = this.props;
    const {
      display
    } = this.state;
    if (display) {
      return /*#__PURE__*/_react.default.createElement(_Modal.default, {
        header: header,
        closeModalCallback: this.closeModal,
        portalContainer: portalContainer,
        fullWidth: fullWidth,
        display: display,
        footer: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
          type: "submit",
          className: "button is-primary is-pulled-right",
          onClick: this.closeModal
          // eslint-disable-next-line jsx-a11y/no-autofocus
          ,
          autoFocus: true
        }, "Ok"))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "is-3 has-text-left"
      }, message));
    }
    return null;
  }
}
exports.default = OkModal;
OkModal.propTypes = {
  closeModalCallback: _propTypes.default.func,
  portalContainer: _propTypes.default.node,
  fullWidth: _propTypes.default.bool,
  display: _propTypes.default.bool,
  header: _propTypes.default.string,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Object)]).isRequired
};
OkModal.defaultProps = {
  closeModalCallback: () => {},
  fullWidth: false,
  display: true
};
//# sourceMappingURL=OkModal.js.map